window.ContactFormHelper = (function($) {
  var obj = {};
  var local = {};  // <-- Local namespace
  obj.registerContactFormHandler = function(callback_method) {
    local.registerContactFormHandler(callback_method);
  };

  var registeredForms = [];

  var defaultCallback = function() {
    var mailSentContainer = $('.mail-sent');
    mailSentContainer.fadeIn("slow", function() {
      mailSentContainer.find('.gridder-close-btn').on('click', function(event) {
        event.preventDefault();
        mailSentContainer.animate({
          height: 'toggle'
        } , {
          duration: 400,
          specialEasing: 'easeInOutExpo'
        });
        return false;
      });
    });
  }

  var uploadButtonHandler = local.uploadButtonHandler = function() {
    var button_selector = '.contact-form__attachment';
    var target_selector = '#contact_form-attachments';

    $(button_selector).on('change', function() {
      $(target_selector).html('');
      for (index = 0; index < this.files.length; ++index) {
        $(target_selector).append('<div class="upload-file-entry">' + this.files[index].name + '<a href="#"><span class="fa fa-remove remove-upload-file"></span></a></div>');
      }
      $(target_selector + ' .remove-upload-file').on('click', function(event) {
        $(button_selector).val("");
        $(target_selector).html("");
        event.preventDefault();
      });
    });
  }

  var registerContactFormHandler = local.registerContactFormHandler = function(callback_method) {
    local.uploadButtonHandler();
    $('[data-behavior=contact-form]').on('submit', function(event) {
      var form = event.currentTarget;
      if (typeof FormData === 'function') {
        if (registeredForms.indexOf(form) === -1) {
          event.preventDefault();

          var action = form.action;
          var formData = new FormData(form);

          $.ajax({
            url: action,
            data: formData,
            method: 'POST',
            contentType: false,
            processData: false
          }).done(function(response) {

            $(form).fadeOut("slow", function() {
              $(form).replaceWith(response.html);

              if (response.status === 'ok') {
                // send tracking for sucessful submit
                ga('send', 'event', 'contact form', 'submit');
                if (typeof callback_method === "function") {
                  callback_method();
                } else {
                  defaultCallback();
                }
              } else {
                registerContactFormHandler(callback_method);
              }

              selectize_all_selects();
            });
          }).error(function(response) {
            registerContactFormHandler(callback_method);
          });
          registeredForms.push(form);
          return false;
        }
      }

    });
  };

  return obj;
})($);
